import { Injectable } from '@angular/core';
import { TemplateConfigurationBaseService } from './template-configuration-base.service';
import { TransactionTemplateConfigurationService } from './transaction-template-configuration.service';

@Injectable()
/**
 * Factory service for getting template configurations
 */
export class TemplateConfigurationFactory {

    private services: TemplateConfigurationBaseService[];

    constructor(
        private transactionTemplateConfigurationService: TransactionTemplateConfigurationService
    ) {
        this.services = [];
        this.services.push(transactionTemplateConfigurationService);
    }

    /**
     * Get the template configuration service
     */
    public create(): TemplateConfigurationBaseService {
        return this.services[0];
    }
}
